import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardService from "../../services/DashboardService";
import AuthService from "../../services/AuthService";
import CallsLineGraph from "./CallsLineGraph";
import axios from "axios";
import PieChart from "./PieChart";
import WelcomePopup from "./WelcomePopup";
import EmployeeWelcomePopup from "./EmployeeWelcomePopup";
import { FaEye, FaUser } from "react-icons/fa";
import RegisterUserService from "../../services/RegisterUserService";
import LeadService from "../../services/LeadService";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Dashboard() {
  debugger;
  const [isLoggedIn, setIsLoggedIn] = useState(AuthService.isAuthenticated());
  const navigate = useNavigate();
  const [leadCount, setLeadCount] = useState(0);
  const [leadAssignedCount, setLeadAssignedCount] = useState(0);
  const [interestedCount, setInterestedCount] = useState(0);
  const [upcomingVisitCount, setUpcomingVisitCount] = useState(0);
  const [phoneNotPickedCount, setPhoneNotPickedCount] = useState(0);
  const [invalidNumberCount, setInvalidNumberCount] = useState(0);
  const [contactAfterSomeTimeCount, setContactAfterSomeTimeCount] = useState(0);
  const [callBackLaterCount, setCallBackLaterCount] = useState(0);
  const [totalCallsCount, setTotalCallsCount] = useState(0);
  const [visitedCount, setVisitedCount] = useState(0);
  const [hotClientCount, setHotClientCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const queryParam = useQuery();
  const [UserId] = useState(
    queryParam.get("id") || AuthService.getCurrentUser().UserId
  );
  const userRole = AuthService.getLoggedInRoleId();

  const currentUserId = AuthService.getCurrentUser().UserId;

  const [selectedEmployee, setSelectedEmployee] = useState(currentUserId);

  const [employees, setEmployees] = useState([]);

  const [showPopup, setShowPopup] = useState(false);

  const currentDate = new Date();
  const formattedCurrentDate = currentDate.toISOString().split("T")[0];
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const formattedStartOfMonth = startOfMonth.toISOString().split("T")[0];

  const yesterday = new Date(currentDate);
  yesterday.setDate(currentDate.getDate() - 1);
  const formattedyesterday = yesterday.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(formattedCurrentDate);
  const [endDate, setEndDate] = useState(formattedCurrentDate);

  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0];

  const [leadStatus, setLeadStatus] = useState([]);
  const clientId = AuthService.getLoggedInClientId();

  useEffect(() => {
    const hasShownPopup = localStorage.getItem("hasShownPopup");
    if (!hasShownPopup) {
      setShowPopup(true);
      localStorage.setItem("hasShownPopup", "true");
    }
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    const fetchLeadStatus = async () => {
      try {
        const leadstatus = await LeadService.getAllLeadStatus();
        setLeadStatus(leadstatus);
      } catch (error) {
        console.error("Error fetching lead status:", error);
      }
    };

    fetchLeadStatus();
  }, [UserId]);

  useEffect(() => {
    async function fetchEmployees() {
      try {
        const users = await RegisterUserService.getEmployessByRoleId(4);
        setEmployees(users);
        if (users.length > 0) {
          setSelectedEmployee(currentUserId);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    }
    fetchEmployees();
  }, [currentUserId]);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      setIsLoggedIn(true);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    handleGetDashboardCards();
  }, [UserId, startDate, endDate]);

  async function handleGetDashboardCards() {
    setLoading(true);
    try {
      let userId;
      if (selectedEmployee == currentUserId) {
        userId = UserId;
      } else {
        userId = selectedEmployee;
      }

      const response = await DashboardService.getDashboardCards(
        selectedEmployee,
        clientId,
        startDate,
        endDate
      );
      setLeadCount(response.leadCount || 0);
      setInterestedCount(response.interestedCount || 0);
      setUpcomingVisitCount(response.upcomingVisitCount || 0);
      setPhoneNotPickedCount(response.phoneNotPickedCount || 0);
      setInvalidNumberCount(response.invalidNumberCount || 0);
      setContactAfterSomeTimeCount(response.contactAfterSomeTimeCount || 0);
      setCallBackLaterCount(response.callBackLaterCount || 0);
      setTotalCallsCount(response.totalCallsCount || 0);
      setLeadAssignedCount(response.leadAssignedCount || 0);
      setVisitedCount(response.visitedCount || 0);
      setHotClientCount(response.hotClientCount || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const handleDateChange = (event) => {
    const value = event.target.value;
    const today = formattedCurrentDate;
    const currentYear = new Date().getFullYear();

    if (value === "today") {
      setStartDate(today);
      setEndDate(today);
    } else if (value === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const formattedYesterday = yesterday.toISOString().split("T")[0];
      setStartDate(formattedYesterday);
      setEndDate(formattedYesterday);
    } else if (value === "last10days") {
      setStartDate(formattedTenDaysAgo);
      setEndDate(today);
    } else if (value === "thisMonth") {
      setStartDate(formattedStartOfMonth);
      setEndDate(today);
    } else if (value === "lastMonth") {
      const lastMonthDate = new Date();
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      lastMonthDate.setDate(1);
      const formattedStartOfLastMonth = lastMonthDate
        .toISOString()
        .split("T")[0];

      lastMonthDate.setMonth(lastMonthDate.getMonth() + 1);
      lastMonthDate.setDate(0);
      const formattedEndOfLastMonth = lastMonthDate.toISOString().split("T")[0];

      setStartDate(formattedStartOfLastMonth);
      setEndDate(formattedEndOfLastMonth);
    } else if (value === "thisYear") {
      const startOfYear = `${currentYear}-01-01`;
      setStartDate(startOfYear);
      setEndDate(today);
    } else if (value === "lastYear") {
      const lastYear = currentYear - 1;
      const startOfLastYear = `${lastYear}-01-01`;
      const endOfLastYear = `${lastYear}-12-31`;
      setStartDate(startOfLastYear);
      setEndDate(endOfLastYear);
    }
  };

  const Role = {
    SUPERADMIN: { roleId: 1, roleName: "SuperAdmin" },
    ADMIN: { roleId: 2, roleName: "Admin" },
    MANAGER: { roleId: 3, roleName: "Manager" },
    EMPLOYEE: { roleId: 4, roleName: "Employee" },
  };

  return (
    <div>
      {/* {userRole== Role.EMPLOYEE.roleId  && (
      <EmployeeWelcomePopup visible={showPopup} onClose={handleClosePopup} />
     )}

      {(userRole== Role.SUPERADMIN.roleId || userRole == Role.ADMIN.roleId || userRole == Role.MANAGER.roleId) && (
       <WelcomePopup visible={showPopup} onClose={handleClosePopup} />
      )} */}

      <div class="row">
        <div class="mb-4">
          <div className="form-group row ">
            {(userRole == Role.SUPERADMIN.roleId ||
              userRole == Role.ADMIN.roleId ||
              userRole == Role.MANAGER.roleId) && (
              <div className="form-group d-flex col-md-3">
                <label className="col-5 dashboardFilterPadding">
                  {" "}
                  Select User:
                </label>
                <select
                  className="form-control"
                  value={selectedEmployee || ""}
                  onChange={(e) => {
                    setSelectedEmployee(e.target.value);
                    handleGetDashboardCards();
                  }}
                >
                  <option value={currentUserId}>Current User</option>
                  {employees.map((employee) => (
                    <option key={employee.id} value={employee.id}>
                      {employee.firstName} {employee.lastName}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="d-flex col-md-3">
              <label className="col-3 dashboardFilterPadding">Select:</label>
              <select
                className="form-control"
                onChange={handleDateChange}
                defaultValue="today"
              >
                <option value="">Select</option>
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="last10days">Last 10 Days</option>
                <option value="thisMonth">This Month</option>
                <option value="lastMonth">Last Month</option>
                <option value="thisYear">This Year</option>
                <option value="lastYear">Last Year</option>
              </select>
            </div>
            <div className="d-flex col-md-3">
              <label className="col-sm-2 dashboardFilterPadding"> From: </label>
              <input
                className="form-control"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="d-flex col-md-2">
              <label className="col-sm-2 dashboardFilterPadding"> To: </label>
              <input
                className="form-control"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div class="col-md-1">
              <a
                class="btn bg-gradient-dark mb-0 "
                href="javascript:;"
                onClick={handleGetDashboardCards}
              >
                <i class="material-symbols-rounded text-sm">search</i>
                &nbsp;&nbsp; 
              </a>
            </div>
          </div>
        </div>
        {(userRole == Role.SUPERADMIN.roleId ||
          userRole == Role.ADMIN.roleId ||
          userRole == Role.MANAGER.roleId) && (
          <div class="col-xl-2 col-sm-3 mb-xl-0 mb-4">
            <div class="card">
              <div class="card-header p-2 ps-3">
                <div class="d-flex justify-content-between">
                  <div>
                    <p class="text-sm mb-0 text-capitalize">Lead's</p>
                    <h4 class="mb-0">{leadCount}</h4>
                  </div>
                  <div class="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                    <i class="material-symbols-rounded opacity-10">weekend</i>
                  </div>
                </div>
              </div>
              <hr class="dark horizontal my-0" />
              <div class="card-footer p-2 ps-3">
                {/* <p class="mb-0 text-sm"><span class="text-success font-weight-bolder">+55% </span>than last week</p> */}
                <div
                  onClick={() =>
                    navigate(
                      `/filteredLeads/${selectedEmployee}/${startDate}/${endDate}`
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  <FaEye className="mr-1" />
                  View
                </div>
              </div>
            </div>
          </div>
        )}
        <div class="col-xl-2 col-sm-3 mb-xl-0 mb-4">
          <div class="card">
            <div class="card-header p-2 ps-3">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Assigned Leads</p>
                  <h4 class="mb-0">{leadAssignedCount}</h4>
                </div>
                <div class="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i class="material-symbols-rounded opacity-10">weekend</i>
                </div>
              </div>
            </div>
            <hr class="dark horizontal my-0" />
            <div class="card-footer p-2 ps-3">
              <div
                onClick={() =>
                  navigate(
                    `/filteredDashboarddata/${selectedEmployee}/${startDate}/${endDate}`
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <FaEye className="mr-1" />
                View
              </div>

              {/* <p class="mb-0 text-sm"><span class="text-success font-weight-bolder">+55% </span>than last week</p> */}
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-sm-6 mb-xl-0 mb-4">
          <div class="card">
            <div class="card-header p-2 ps-3">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Interested</p>
                  <h4 class="mb-0">{interestedCount}</h4>
                </div>
                <div class="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i class="material-symbols-rounded opacity-10">person</i>
                </div>
              </div>
            </div>
            <hr class="dark horizontal my-0" />
            <div class="card-footer p-2 ps-3">
              {/* <p class="mb-0 text-sm"><span class="text-success font-weight-bolder">+3% </span>than last month</p> */}
              <div
                onClick={() =>
                  navigate(
                    `/filteredDataEmployee/${selectedEmployee}/${startDate}/${endDate}/2`
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <FaEye className="mr-1" />
                View
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-sm-6 mb-xl-0 mb-4">
          <div class="card">
            <div class="card-header p-2 ps-3">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Hot Client</p>
                  <h4 class="mb-0">{hotClientCount}</h4>
                </div>
                <div class="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i class="material-symbols-rounded opacity-10">leaderboard</i>
                </div>
              </div>
            </div>
            <hr class="dark horizontal my-0" />
            <div class="card-footer p-2 ps-3">
              {/* <p class="mb-0 text-sm"><span class="text-danger font-weight-bolder">-2% </span>than yesterday</p> */}
              <div
                onClick={() =>
                  navigate(
                    `/filteredDataEmployee/${selectedEmployee}/${startDate}/${endDate}/1`
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <FaEye className="mr-1" />
                View
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-sm-6 mb-xl-0 mb-4">
          <div class="card">
            <div class="card-header p-2 ps-3">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Upcoming Visit</p>
                  <h4 class="mb-0">{upcomingVisitCount}</h4>
                </div>
                <div class="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i class="material-symbols-rounded opacity-10">leaderboard</i>
                </div>
              </div>
            </div>
            <hr class="dark horizontal my-0" />
            <div class="card-footer p-2 ps-3">
              {/* <p class="mb-0 text-sm"><span class="text-danger font-weight-bolder">-2% </span>than yesterday</p> */}
              <div
                onClick={() =>
                  navigate(
                    `/filteredDataEmployee/${selectedEmployee}/${startDate}/${endDate}/8`
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <FaEye className="mr-1" />
                View
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-sm-6">
          <div class="card">
            <div class="card-header p-2 ps-3">
              <div class="d-flex justify-content-between">
                <div>
                  <p class="text-sm mb-0 text-capitalize">Visited</p>
                  <h4 class="mb-0">{visitedCount}</h4>
                </div>
                <div class="icon icon-md icon-shape bg-gradient-dark shadow-dark shadow text-center border-radius-lg">
                  <i class="material-symbols-rounded opacity-10">weekend</i>
                </div>
              </div>
            </div>
            <hr class="dark horizontal my-0" />
            <div class="card-footer p-2 ps-3">
              {/* <p class="mb-0 text-sm"><span class="text-success font-weight-bolder">+5% </span>than yesterday</p> */}
              <div
                onClick={() =>
                  navigate(
                    `/filteredDataEmployee/${selectedEmployee}/${startDate}/${endDate}/10`
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <FaEye className="mr-1" />
                View
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-6 mt-4 mb-4">
          <div class="card">
            <div class="card-body">
              <h6 class="mb-0 ">Call Records</h6>
              {/* <p class="text-sm ">Last Campaign Performance</p> */}
              <div class="pe-2">
                <div class="chart">
                  {/* <canvas id="chart-bars" class="chart-canvas" height="170"></canvas> */}
                  <CallsLineGraph
                    totalCallsCount={totalCallsCount}
                    phoneNotPickedCount={phoneNotPickedCount}
                    invalidNumberCount={invalidNumberCount}
                    contactAfterSomeTimeCount={contactAfterSomeTimeCount}
                    callBackLaterCount={callBackLaterCount}
                  />
                </div>
              </div>
              <hr class="dark horizontal" />
              <div class="d-flex ">
                <i class="material-symbols-rounded text-sm my-auto me-1">
                  schedule
                </i>
                <p class="mb-0 text-sm"> campaign sent 2 days ago </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 mt-4 mb-4">
          <div class="card ">
            <div class="card-body">
              <h6 class="mb-0 "> Leads and Call Statistics </h6>
              {/* <p class="text-sm "> (<span class="font-weight-bolder">+15%</span>) increase in today sales. </p> */}
              <div class="pe-2">
                <div class="chart">
                  <PieChart
                    leadCount={leadCount}
                    leadAssignedCount={leadAssignedCount}
                    upcomingVisitCount={upcomingVisitCount}
                    interestedCount={interestedCount}
                    totalCallsCount={totalCallsCount}
                  />
                  {/* <canvas id="chart-line" class="chart-canvas" height="170"></canvas> */}
                </div>
              </div>
              <hr class="dark horizontal" />
              <div class="d-flex ">
                <i class="material-symbols-rounded text-sm my-auto me-1">
                  schedule
                </i>
                <p class="mb-0 text-sm"> updated 4 min ago </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 mt-4">
          <div class="card h-100">
            <div class="card-header pb-0">
              <h6>Orders overview</h6>
              <p class="text-sm">
                <i class="fa fa-arrow-up text-success" aria-hidden="true"></i>
                <span class="font-weight-bold">24%</span> this month
              </p>
            </div>
            <div class="card-body p-3">
              <div class="timeline timeline-one-side">
                <div class="timeline-block mb-3">
                  <span class="timeline-step">
                    <i class="material-symbols-rounded text-success text-gradient">
                      notifications
                    </i>
                  </span>
                  <div class="timeline-content">
                    <h6 class="text-dark text-sm font-weight-bold mb-0">
                      $2400, Design changes
                    </h6>
                    <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
                      22 DEC 7:20 PM
                    </p>
                  </div>
                </div>
                <div class="timeline-block mb-3">
                  <span class="timeline-step">
                    <i class="material-symbols-rounded text-danger text-gradient">
                      code
                    </i>
                  </span>
                  <div class="timeline-content">
                    <h6 class="text-dark text-sm font-weight-bold mb-0">
                      New order #1832412
                    </h6>
                    <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
                      21 DEC 11 PM
                    </p>
                  </div>
                </div>
                <div class="timeline-block mb-3">
                  <span class="timeline-step">
                    <i class="material-symbols-rounded text-info text-gradient">
                      shopping_cart
                    </i>
                  </span>
                  <div class="timeline-content">
                    <h6 class="text-dark text-sm font-weight-bold mb-0">
                      Server payments for April
                    </h6>
                    <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
                      21 DEC 9:34 PM
                    </p>
                  </div>
                </div>
                <div class="timeline-block mb-3">
                  <span class="timeline-step">
                    <i class="material-symbols-rounded text-warning text-gradient">
                      credit_card
                    </i>
                  </span>
                  <div class="timeline-content">
                    <h6 class="text-dark text-sm font-weight-bold mb-0">
                      New card added for order #4395133
                    </h6>
                    <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
                      20 DEC 2:20 AM
                    </p>
                  </div>
                </div>
                <div class="timeline-block mb-3">
                  <span class="timeline-step">
                    <i class="material-symbols-rounded text-primary text-gradient">
                      key
                    </i>
                  </span>
                  <div class="timeline-content">
                    <h6 class="text-dark text-sm font-weight-bold mb-0">
                      Unlock packages for development
                    </h6>
                    <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
                      18 DEC 4:54 AM
                    </p>
                  </div>
                </div>
                <div class="timeline-block">
                  <span class="timeline-step">
                    <i class="material-symbols-rounded text-dark text-gradient">
                      payments
                    </i>
                  </span>
                  <div class="timeline-content">
                    <h6 class="text-dark text-sm font-weight-bold mb-0">
                      New order #9583120
                    </h6>
                    <p class="text-secondary font-weight-bold text-xs mt-1 mb-0">
                      17 DEC
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <div class="">
           <div className="row md-5 m-2 p-2">
                <div class="col-md-6 ">
                  <div class="">
                    <div class="">
                      <div>
                        <CallsLineGraph
                          totalCallsCount={totalCallsCount}
                          phoneNotPickedCount={phoneNotPickedCount}
                          invalidNumberCount={invalidNumberCount}
                          contactAfterSomeTimeCount={contactAfterSomeTimeCount}
                          callBackLaterCount={callBackLaterCount}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-1 ">
              </div>

              <div class="col-md-5">
                  <div class="">
                    <div class="">
                      <div>
                          <PieChart
                            leadCount={leadCount}
                            leadAssignedCount={leadAssignedCount}
                            upcomingVisitCount={upcomingVisitCount}
                            interestedCount={interestedCount}
                            totalCallsCount={totalCallsCount}
                          />
                      </div>
                    </div>
                  </div>
                </div>
              </div> 

           
          </div>
        </div>
      )} */}
    </div>
  );
}

export default Dashboard;
